import { EmailThreadApiClient } from "@/clients/emailThreadApiClient";
import type {
  EmailProviderConnection,
  EmailProviderConnectionScope,
  EmailThreadCompanyConnection,
  EmailThreadCompanyConnectionWithCompany,
} from "@/types/emailThread";

export class EmailThreadService {
  private client: EmailThreadApiClient;

  constructor() {
    this.client = new EmailThreadApiClient();
  }

  async initiateGmailOAuth(opts: {
    connectionScope: EmailProviderConnectionScope;
    companyId?: string;
    callbackUrl?: string;
  }): Promise<string> {
    const { authUrl } = await this.client.initiateGmailOAuth(opts);
    return authUrl;
  }

  async getEmailProviderStatus(connectionId: string): Promise<EmailProviderConnection | null> {
    const { connection } = await this.client.getEmailProviderStatus(connectionId);
    return connection;
  }

  async listConnections(companyId?: string): Promise<EmailProviderConnection[]> {
    const { connections } = await this.client.listConnections(companyId);
    return connections;
  }

  async disconnectGmail(connectionId: string): Promise<void> {
    await this.client.disconnectGmail(connectionId);
  }

  async listPendingConnections(companyId: string): Promise<EmailThreadCompanyConnection[]> {
    const { connections } = await this.client.listPendingConnections(companyId);
    return connections;
  }

  async listAllPendingConnections(): Promise<EmailThreadCompanyConnectionWithCompany[]> {
    const { connections } = await this.client.listAllPendingConnections();
    return connections;
  }

  async approveConnection(connectionId: string): Promise<EmailThreadCompanyConnection> {
    const { connection } = await this.client.approveConnection(connectionId);
    return connection;
  }

  async rejectConnection(connectionId: string): Promise<EmailThreadCompanyConnection> {
    const { connection } = await this.client.rejectConnection(connectionId);
    return connection;
  }

  async rejectGlobal(threadId: string): Promise<void> {
    await this.client.rejectGlobal(threadId);
  }

  async unrejectGlobal(threadId: string): Promise<void> {
    await this.client.unrejectGlobal(threadId);
  }
}
